import { getDatabase, onValue, query, ref } from "firebase/database";
import { useEffect, useState } from "react";
export default function useJobList(state) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(true);
  const [jobs, setJobs] = useState([]);
  useEffect(() => {
    async function fetchUsers() {
      //databse related works
      const db = getDatabase();
      const jobRef = ref(db, "Jobs");
      const jobQuery = query(jobRef);
      try {
        setError(false);
        setLoading(true);
        //request firebase database;
        onValue(jobQuery, (snapshot) => {
          setLoading(false);
          if (snapshot.exists()) {
            setJobs((prevCashout) => {
              return [...Object.values(snapshot.val())];
            });
          }
        });
      } catch (err) {
        setLoading(false);
        setError(true);
      }
    }
    fetchUsers();
  }, [state]);

  return { loading, error, jobs };
}
